import React, { useEffect, useRef, useState } from "react";
import EncounterRight from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/EncounterRight";
import EncounterLeftPortion from "../../../Patient/PatientDetails/Encounter/Components/EncounterLeftPortion/EncounterLeftPortion";
import { ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest";
import { enumUtil } from "../../../../utils/Enum";
import Loader from "../../../shared/Loader/Loader";
import isNull from "../../../../utils/NullChecking";
import { connect, useSelector } from "react-redux";
import SOAPwithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/SOAP/SOAPwithDetails";
import OtherNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/OtherNote/OtherNotewithDetails";
import GIRPNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/GIRPNote/GIRPNotewithDetails";
import { OpenNewEncounterMenuTabAction, TabActionEncounterMenu } from "../../../../actions/EncounterMenuActions";
import NotificationHandler from "../../../../utils/NotificationHandler";
import Modal from 'react-bootstrap/Modal';
import ReloadGridAction from "../../../../actions/ReloadGridAction";
import { useDispatch } from "react-redux";
import ModalHeader from "../../../Setup/Shared/ModalHeader";
import BIRPNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/BIRPNote/BIRPNotewithDetails";
import DAPNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/DAPNote/DAPNotewithDetails";
import DAPPNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/DAPPNote/DAPPNotewithDetails";
import TherapyNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/TherapyNote/TherapyNotewithDetails";

import { debounce } from "lodash";
import MassageNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/MassageNote/MassageNotewithDetails";
import PhysicalNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/PhysicalNote/PhysicalNotewithDetails";
import CustomNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/CustomNote/CustomNotewithDetails";
import GroupCustomNotewithDetails from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/GroupCustomNote/GroupCustomNotewithDetails";
const EncounterWrapper = (props) => {
    const [patientID, setPatientID] = useState(
        useSelector(state => state.Open_EncounterMenu_Tab.find((pt) => pt.active === true))?.data?.patid || ''
    )
    const API_URL = enumUtil.controller.PatientEncounter
    const API_URL_Wasabi = enumUtil.controller.Wasabi

    let EncounterData =
        useSelector(state =>
            state.Open_EncounterMenu_Tab?.find((pt) => pt.active === true)
                ?.data);
    const [templateDataToApply, setTemplateDataToApply] = useState({})
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [expandAll, setExplandAll] = useState(true);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [data, setData] = useState([])
    const [isRecordSaved, setIsRecordSaved] = useState(false)
    const [isRecordSavedType, setIsRecordSavedType] = useState('')
    const handleCollapseClick = () => {
        setIsCollapsed(!isCollapsed); // Toggle the collapse state
    };

    const [enCounterData, SetEncounterData] = useState({})
    const LoaduserImage = async (url) => {
        try {
            const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": url,
            }, "Download");

            console.log(response.type);

            if (response.type === 'application/jpg') {
                const blob = response;
                const objectURL = URL.createObjectURL(blob);
                console.log('objectURL', objectURL);
                return objectURL;
            } else {
                return null;
            }

        } catch (error) {
            console.error('Image load failed:', error);
            // Return null instead of throwing error
            return null;
        }
    };
    const LoadData = async () => {
        setData([]);
        setIsRecordSaved(false);
        setIsRecordSavedType('');
        setIsLoading(true);

        try {
            const response = await ServerRequestProtected(API_URL + "/GetSummaryData", 'post', {
                "ID": patientID,
                "TableName": enumUtil.enumAPITableName.PatientProblemList,
            });

            setIsLoading(false);
            console.log(response, 'response');

            setData(response);
            if (response?.PatientData?.[0]?.ProfilePictureURL) {
                const imageURL = await LoaduserImage(response.PatientData[0].ProfilePictureURL);
                if (imageURL) {
                    response.PatientData[0].ProfilePictureURL = imageURL;
                } else {
                    // Optionally, set it to null or a fallback image
                    response.PatientData[0].ProfilePictureURL = null;
                }
            }

            SetEncounterData(response?.PatientData?.[0]);

        } catch (error) {
            console.error('Error loading summary data:', error);
            setIsLoading(false);
        }
    };


    useEffect(() => {
        console.log("prop reload Encounter")
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadData()
                }
            })
            if (data.length === 0) {
                LoadData()
            }
        }
    }, [props.Reload])

    useEffect(() => {
        if (!isRecordSaved) return;
        LoadData();
    }, [isRecordSaved])

    const handleReloadComponent = () => {
        setReload(prev => !prev)
    }

    useEffect(() => {
        console.log(EncounterData?.groupEncounter?.showGroupNote, 'groupEncounter');
        if (EncounterData?.groupEncounter?.showGroupNote) {
            handleCollapseClick()
        }
    }, [])
    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className={`ar_encounter_main_screen d-flex ${isCollapsed ? 'collapsed' : ''}`}>
                {EncounterData?.groupEncounter?.showGroupNote ? null :
                    <div className="collaspe-sidebar d-flex justify-content-center align-items-center position-absolute" onClick={handleCollapseClick}>
                        <i className="icon-angle-left  fs-11"></i>
                    </div>
                }
                <div className="encounter_summary col-md-3  position-relative">
                    <EncounterLeftPortion enCounterData={enCounterData} data={data} expandAll={expandAll} setIsRecordSaved={setIsRecordSaved} patientID={patientID}
                        setIsRecordSavedType={setIsRecordSavedType} setTemplateDataToApply={setTemplateDataToApply} {...props} Reload={reload} id={[{ key: 218, name: 'Target Record' }]} isCalledFrom={`EncounterMenu`} />
                </div>

                <div className="encounter_detail col-md-9 position-relative">
                    {/* <EncounterRight
                        templateDataToApply={templateDataToApply} setTemplateDataToApply={setTemplateDataToApply}
                        {...props} patientID={patientID} isRecordSaved={isRecordSaved} 
                        isRecordSavedType={isRecordSavedType}/> */}
                    <TemplateView
                        templateDataToApply={templateDataToApply} setTemplateDataToApply={setTemplateDataToApply}
                        {...props} patientID={patientID} isRecordSaved={isRecordSaved}
                        isRecordSavedType={isRecordSavedType}
                        reload={reload}
                        handleReloadComponent={handleReloadComponent} />

                </div >
            </div >
        </>
    );
}

const action = {
    TabActionEncounterMenu,
};

export default connect(null, action)(EncounterWrapper);


const TemplateView = (props) => {
    let dispatch = useDispatch();
    let EncounterType =
        useSelector(state =>
            state.Open_EncounterMenu_Tab?.find((pt) => pt.active === true)
                ?.data?.type);
    let EncounterIDR =
        useSelector(state =>
            state.Open_EncounterMenu_Tab?.find((pt) => pt.active === true)
                ?.data?.id);
    let EncounterScrollTo =
        useSelector(state =>
            state.Open_EncounterMenu_Tab?.find((pt) => pt.active === true)
                ?.data?.scrollTo);
    let EncounterData =
        useSelector(state =>
            state.Open_EncounterMenu_Tab?.find((pt) => pt.active === true)
                ?.data);
    const API_URL_GENERAL = enumUtil.controller.General
    const [isLoading, setIsLoading] = useState(false);
    const [encounterType, setEncounterType] = useState('');
    const [encounterID, setEncounterID] = useState('');
    const [scrollTo, setScrollTo] = useState('');
    const [encounterData, setEncounterData] = useState('');
    const [isNoteTypeChangeConfirmation, setIsNoteTypeChangeConfirmation] = useState(false);

    useEffect(() => {
        setEncounterType(EncounterType);
        setEncounterID(EncounterIDR);
        setEncounterData(EncounterData)
    }, [])

    useEffect(() => {
        if (!isNull(encounterID) && (encounterID !== EncounterData?.id)) return;
        setScrollTo(EncounterScrollTo || '');
    }, [EncounterScrollTo])

    const handleRemoveScrollKey = () => {
        let obj = {
            active: true,
            key: 2,
            name: "Encounter Menu",
            data: {
                name: `${encounterData.name}`,
                id: encounterData.id,
                patid: encounterData.patid,
                type: encounterData.NoteType,
                scrollTo: null,
                time: new Date(),
                groupEncounter: {
                    isGroupEncounter: encounterData.isGroupEncounter,
                    GroupIdentifier: encounterData.GroupIdentifier
                }
            },
        }
        props.TabActionEncounterMenu(obj);
    }

    const handleUpdateNoteType = (newType) => {
        let obj = {
            active: true,
            key: 2,
            name: "Encounter Menu",
            data: {
                name: `${encounterData.name}`,
                id: encounterData.id,
                patid: encounterData.patid,
                type: newType,
                scrollTo: null,
                time: new Date(),
                groupEncounter: {
                    isGroupEncounter: encounterData.isGroupEncounter,
                    GroupIdentifier: encounterData.GroupIdentifier
                }
            },
        }
        props.TabActionEncounterMenu(obj);
        dispatch(ReloadGridAction({ EncounterMenuSearch: true }));
    }
    useEffect(() => {
        if (scrollTo === null) {
            handleRemoveScrollKey();
        }
    }, [scrollTo]);

    const Heading = () => {
        return <p className='heading Rejected_clr'>Change Note Type?</p>;
    };
    const confirmationMsg = () => {
        return new Promise((resolve, reject) => {
            const handleConfirmation = (userConfirmed) => {
                if (userConfirmed) {
                    resolve(userConfirmed);
                } else { reject(userConfirmed); }
                setIsNoteTypeChangeConfirmation(<></>);
            };
            setIsNoteTypeChangeConfirmation(
                <Modal show={true} onHide={() => handleConfirmation(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
                    <ModalHeader HeaderName={Heading} DeletePopup={""} isClosed={() => handleConfirmation(false)} key={6331} Name={'ChanegNoteType'} />
                    <Modal.Body>
                        <div className='ar-alert d-flex mb-12'>
                            <i className='icon-Vector13 mt-1'></i>
                            <div>
                                <p className='text ms-1'>Changing the note type will remove all the data you’ve entered. Do you want to continue?</p>
                            </div>
                        </div>
                    </Modal.Body>

                    <div className="modal_footer za_br_light br-top-1 pt-2 ">
                        <div className='za-button text-end d-flex justify-content-end gap-2'>
                            <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => handleConfirmation(false)}>Cancel</button>
                            <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleConfirmation(true)}>Continue</button>
                        </div>
                    </div>
                </Modal>)
        })
    }

    const handleSave = (newValue) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/SaveSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": encounterData.id,
            "Data": {
                "NoteType": newValue,
            },
        }).then((response) => {
            setIsLoading(false)
            handleUpdateNoteType(newValue);
            setEncounterType(newValue)
            NotificationHandler("Note Type Changed", enumUtil.enumtoaster.success);
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler("Note Type Change Failed!", enumUtil.enumtoaster.error);
        })
    }

    const handleNoteTypeChange = async (oldValue, newValue, getSaveData, setSearchParam, setSearchValue, newDisplay) => {

        if (!isNull(oldValue) && oldValue !== newValue) {
            const userConfirmed = await confirmationMsg();
            if (!userConfirmed) return false;

            // setSearchParam((prev) => ({ ...prev,  RemoveEncounterData: "true",  NoteType: newValue }));
            setSearchParam((prev) => ({ ...prev, RemoveEncounterData: "true" }));
            setSearchValue(prev => ({ ...prev, NoteType: newDisplay + "" }));

            if (typeof getSaveData === "function") {
                await handleSave(newValue);
                // setIsNoteChangedTo(newValue);
            }
            return true;
        }
        setSearchParam((prev) => ({ ...prev, NoteType: newValue }));
        setSearchValue(prev => ({ ...prev, NoteType: newDisplay + "" }));

        return true;
    };

    let EncounterMenuID = useSelector((state) => state.Open_EncounterMenu_Tab.find((pt) => pt.active === true)?.data.id || '');
    let EncounterMenuData = useSelector(state => state.EncounterMenuRecordReducer);
    let encounterIDExists = EncounterMenuData.some(enc => enc.ID === EncounterMenuID);
    let EncounterMenuTab = useSelector((state) => state.Open_EncounterMenu_Tab);

    let FirstEncounterMenu = '';
    let LastEncounterMenu = '';
    if (EncounterMenuData.length > 0) {
        FirstEncounterMenu = EncounterMenuData[0]
        LastEncounterMenu = EncounterMenuData[EncounterMenuData.length - 1]
    }

    const handleNext = () => {
        let nextEncounterMenuID;
        let nextEncounterMenuName;
        let EncounterMenuNoteType;
        let EncounterMenuPatientID;
        // let nextEncounterID
        for (let i = 0; i < EncounterMenuData.length; i++) {
            let item = EncounterMenuData[i]
            if (item.ID === EncounterMenuID + "") {

                nextEncounterMenuID = EncounterMenuData[i + 1]['ID']
                nextEncounterMenuName = EncounterMenuData[i + 1]['name']
                EncounterMenuNoteType = EncounterMenuData[i + 1]['type']
                EncounterMenuPatientID = EncounterMenuData[i + 1]['PatientID']
                // nextEncounterID =  EncounterMenuData[i + 1]['EncounterID']
            }
        }
        console.log("EncounterMenuPatientID123", EncounterMenuPatientID, EncounterMenuData?.find(enc => String(EncounterMenuID) === enc.ID))
        // removing the current active encounter and adding new there
        if (!isNull(nextEncounterMenuID)) {
            let obj = {
                key: 2,
                name: "Encounter Menu",
                active: true,
                data: {
                    name: nextEncounterMenuName,
                    id: nextEncounterMenuID + "",
                    patid: EncounterMenuPatientID,
                    type: EncounterMenuNoteType,
                    time: new Date(),
                    // EncounterID: nextEncounterID,
                },
            };
            let updatedData = EncounterMenuTab.filter((item) => item.data.id !== nextEncounterMenuID)
                .map((item) => {
                    if (item.data.id === EncounterMenuID) {
                        return obj;
                    }
                    return {
                        ...item,
                        active: false,
                    };
                });
            dispatch(OpenNewEncounterMenuTabAction(updatedData))
        }
    }
    const debouncedNext = useRef(debounce(() => { handleNext(); }, 300)).current;
    const handleBack = () => {
        let nextEncounterMenuID;
        let nextEncounterMenuName;
        let EncounterMenuNoteType;
        let EncounterMenuPatientID;
        // let nextEncounterID
        for (let i = 0; i < EncounterMenuData.length; i++) {
            let item = EncounterMenuData[i]
            if (item.ID === EncounterMenuID + "") {

                nextEncounterMenuID = EncounterMenuData[i - 1]['ID']
                nextEncounterMenuName = EncounterMenuData[i - 1]['name']
                EncounterMenuNoteType = EncounterMenuData[i - 1]['type']
                EncounterMenuPatientID = EncounterMenuData[i - 1]['PatientID']
                // nextEncounterID =  EncounterMenuData[i + 1]['EncounterID']
            }
        }
        // removing the current active encounter and adding new there
        if (!isNull(nextEncounterMenuID)) {
            let obj = {
                key: 2,
                name: "Encounter Menu",
                active: true,
                data: {
                    name: nextEncounterMenuName,
                    id: nextEncounterMenuID + "",
                    patid: EncounterMenuPatientID,
                    type: EncounterMenuNoteType,
                    time: new Date(),
                    // EncounterID: nextEncounterID
                },
            };
            let updatedData = EncounterMenuTab.filter((item) => item.data.id !== nextEncounterMenuID)
                .map((item) => {
                    if (item.data.id === EncounterMenuID) {
                        return obj;
                    }
                    return {
                        ...item,
                        active: false,
                    };
                });
            dispatch(OpenNewEncounterMenuTabAction(updatedData))
        }
    }
    const debouncedBack = useRef(debounce(() => { handleBack(); }, 300)).current;
    useEffect(() => { return () => { debouncedBack.cancel(); }; }, []);

    const isFirstEncounter = !isNull(FirstEncounterMenu.ID) && EncounterMenuID === FirstEncounterMenu.ID;
    const isLastEncounter = !isNull(LastEncounterMenu.ID) && EncounterMenuID === LastEncounterMenu.ID;
    console.log("searchParam NoteType encounterType", encounterType, encounterData)
    console.log("searchParam NoteType encounterType FirstEncounterMenu12",)

    let noteComponent = null;
    if (encounterData?.groupEncounter?.isGroupEncounter === 'true') {
        noteComponent = (
            <GroupCustomNotewithDetails
                key={encounterType}
                {...props}
                handleNoteTypeChange={handleNoteTypeChange}
                encounterID={encounterID}
                encounterType={encounterType}
                encounterDataRedux={encounterData}
                Reload={props?.reload} 
                id={[{ key: 218, name: 'Target Record' }]} 
                isOpenedFrom={'EncounterMenu'}
            />
        );
    } else {
        switch (encounterType) {
            case "SOAP":
                noteComponent = <SOAPwithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "Other":
                noteComponent = <OtherNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "GIRP":
                noteComponent = <GIRPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "BIRP":
                noteComponent = <BIRPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "DAPP":
                noteComponent = <DAPPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "DAP":
                noteComponent = <DAPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "Massage":
                noteComponent = <MassageNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "Physical":
                noteComponent = <PhysicalNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            case "Therapy":
                noteComponent = <TherapyNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
                break;

            default:
                noteComponent = <CustomNotewithDetails key={encounterType} {...props} handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'} />;
            // noteComponent = <GroupCustomNotewithDetails key={encounterType} {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} encounterDataRedux={encounterData} />;
        }
    }

    return (<>
        {/* {props?.isOpenedFrom === 'EncounterMenu' ? */}
        {/* <span class="icon-Reloading-icon1 fs-19 reload-on-top" onClick={props?.handleReloadComponent}><span class="path1"></span><span class="path2"></span></span> */}
        <div className="claims-TabHeader bg-transparent border-0 w-auto">
            <div className="claims-TabHeader__right">
                <div className="d-flex align-items-center gap-2 reload-on-top">
                    <span class="icon-Reloading-icon1 fs-19" onClick={props?.handleReloadComponent}><span class="path1"></span><span class="path2"></span></span>
                    {EncounterMenuData.length > 0 ?
                        <>
                            <button className={(isFirstEncounter || !encounterIDExists) ? "btn disable" : "btn"} onClick={debouncedBack}>
                                <i className="icon-Icon-ionic-md-arrow-round-back"></i>
                            </button>
                            <button className={(isLastEncounter || !encounterIDExists) ? "btn disable" : "btn"} onClick={debouncedNext}>
                                <i className="icon-arrow-right"></i>
                            </button>
                        </>
                        : null}
                </div>
            </div>
        </div>
        {/*  : null} */}
        {isNoteTypeChangeConfirmation}
        {isLoading ? <Loader /> : null}
        {noteComponent}
        {/* SOAP Note*/}
        {/* {encounterType === "SOAP" && <SOAPwithDetails {...props}
        handleNoteTypeChange={handleNoteTypeChange} scrollTo={scrollTo} setScrollTo={setScrollTo} encounterID={encounterID} encounterType={encounterType} Reload={props?.reload} id={[{ key: 218, name: 'Target Record' }]} isOpenedFrom={'EncounterMenu'}/>} */}
    </>
    )
}

